import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { getStoredUser } from '../../helpers/user-storage.util';

@Component({
  selector: 'opt-out-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './opt-out-dialog.component.html',
  styleUrl: './opt-out-dialog.component.scss',
})
export class OptOutDialogComponent {
  _active: boolean = false;
  @Input() set active(value: boolean) {
    this._active = value;
    if (value) this.isSubmitting = false;
  }
  get active() { return this._active; }

  @Output() handleOptOut = new EventEmitter<any>();
  @Output() modalClosed = new EventEmitter<boolean>();

  user = getStoredUser();
  isSubmitting = false;

  closeDialog() {
    this.active = false;
    this.modalClosed.emit(this.active);
  }

  submit() {
    this.isSubmitting = true;
    this.handleOptOut.emit(this.user);
  }
}
